import React, { useState } from "react";
import { Mail, MapPin, Send } from "lucide-react";
import { submitContact } from "../lib/api";
import { toast } from "sonner";

const Contact = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const onChange = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await submitContact(form);
      toast.success(res.message || "Message sent.");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed to send. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-[#050505] text-white">
      <section className="max-w-[1400px] mx-auto px-6 md:px-12 pt-20 md:pt-28 pb-20 grid grid-cols-1 lg:grid-cols-12 gap-16">
        <div className="lg:col-span-5">
          <div className="font-display text-xs tracking-[0.3em] text-[#D10000] mb-4">
            CONTACT
          </div>
          <h1
            className="font-display uppercase leading-[0.9] tracking-tight"
            style={{ fontSize: "clamp(2.75rem, 7vw, 6rem)" }}
          >
            Talk to us.
          </h1>
          <p className="mt-6 text-white/65 leading-relaxed max-w-md">
            Questions about your order, the formulas, or wholesale? Drop us a
            line — we respond within 24 hours, every day of the week.
          </p>

          <div className="mt-12 space-y-6 text-white/80">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 border border-white/10 grid place-items-center shrink-0">
                <Mail className="h-4 w-4 text-[#D10000]" />
              </div>
              <div>
                <div className="font-display text-xs tracking-[0.3em] text-white/40">
                  EMAIL
                </div>
                <div className="mt-1">support@primenax.com</div>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 border border-white/10 grid place-items-center shrink-0">
                <MapPin className="h-4 w-4 text-[#D10000]" />
              </div>
              <div>
                <div className="font-display text-xs tracking-[0.3em] text-white/40">
                  HQ
                </div>
                <div className="mt-1">United States — Made & Shipped</div>
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <form
            onSubmit={onSubmit}
            className="bg-[#0A0A0A] border border-white/10 p-8 md:p-12 space-y-8"
            data-testid="contact-form"
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <Field
                label="Name"
                testid="contact-name-input"
                required
                value={form.name}
                onChange={onChange("name")}
              />
              <Field
                label="Email"
                type="email"
                testid="contact-email-input"
                required
                value={form.email}
                onChange={onChange("email")}
              />
            </div>
            <Field
              label="Subject"
              testid="contact-subject-input"
              value={form.subject}
              onChange={onChange("subject")}
            />
            <div>
              <label className="font-display text-xs tracking-[0.3em] text-white/40 block mb-2">
                MESSAGE
              </label>
              <textarea
                required
                rows={5}
                value={form.message}
                onChange={onChange("message")}
                data-testid="contact-message-input"
                className="w-full bg-transparent border-b border-white/15 focus:border-[#D10000] outline-none py-3 text-white placeholder:text-white/30 resize-none"
                placeholder="What's on your mind?"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="contact-submit-button"
              className="inline-flex items-center gap-3 bg-[#D10000] hover:bg-[#A30000] disabled:opacity-50 text-white font-display text-lg tracking-widest uppercase px-8 py-4 transition-colors"
            >
              <Send className="h-4 w-4" />
              {loading ? "Sending…" : "Send Message"}
            </button>
          </form>
        </div>
      </section>
    </div>
  );
};

const Field = ({ label, testid, ...props }) => (
  <div>
    <label className="font-display text-xs tracking-[0.3em] text-white/40 block mb-2">
      {label.toUpperCase()}
    </label>
    <input
      {...props}
      data-testid={testid}
      className="w-full bg-transparent border-b border-white/15 focus:border-[#D10000] outline-none py-3 text-white placeholder:text-white/30"
    />
  </div>
);

export default Contact;
